export const getInitials = (name?: string | null): string => {
  if (!name) return 'U';

  const words = name.split(' ');
  const firstTwoWords = words.slice(0, 2);

  return firstTwoWords
    .map((word) => word.charAt(0))
    .join('')
    .toUpperCase();
};
